import { createContext } from 'react';

import { PartyInvolved } from '@totem/components/ticketing/ticketing';

interface Context {
  partyInvolved: PartyInvolved;
  token: string;
}

export default createContext<Context>({
  partyInvolved: null,
  token: '',
});
